import type { IconData } from '@stacksjs/iconify-core'

export const arrowRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m359.873 121.377l-22.627 22.627l95.997 95.997H16v32.001h417.24l-95.994 95.994l22.627 22.627L494.498 256z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowRight
